import script from "./LoginView.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginView.vue?vue&type=script&lang=ts&setup=true"

import "./LoginView.vue?vue&type=style&index=0&id=470174b3&lang=scss"

const __exports__ = script;

export default __exports__